import { ProgramComplementaryItem } from '@models/membership/ProgramComplementaryItem'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import {
  MEMBERSHIP_PROGRAMS_URL,
  MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL,
} from '@utils/urls'
import { AxiosError } from 'axios'

const fetchProgramComplementaryItems = (params: TableParams) =>
  SBAPI.FetchPaginated<ProgramComplementaryItem[]>(
    MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL,
    params
  )

const createProgramComplementaryItem = (
  complementaryItem: ProgramComplementaryItem
) =>
  SBAPI.Post(
    `${MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL}`,
    complementaryItem
  ).catch((error: AxiosError) => {
    throw new Error(error.message)
  })

const updateProgramComplementaryItem = (
  complementaryItem: Partial<ProgramComplementaryItem>
) =>
  SBAPI.Put(
    `${MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`,
    complementaryItem
  )

const batchUpdateProgramComplementaryItems = (
  programSlug: string,
  items: { id: number; quantity: number }[]
) =>
  SBAPI.Put(
    `${MEMBERSHIP_PROGRAMS_URL}/${programSlug}/complementary-items/batch-update`,
    { items }
  )

const deleteProgramComplementaryItem = (
  complementaryItem: ProgramComplementaryItem
) =>
  SBAPI.Delete(
    `${MEMBERSHIP_PROGRAM_COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`
  )

export {
  batchUpdateProgramComplementaryItems,
  createProgramComplementaryItem,
  deleteProgramComplementaryItem,
  fetchProgramComplementaryItems,
  updateProgramComplementaryItem,
}
